import { useEffect, useState } from 'react';
import { FaPlus } from 'react-icons/fa';

import ButtonInputRow from './button-input-row/button-input-row.component.jsx';

import {
  Label,
  Select,
  Option,
  AddButton,
  AddButtonRow,
  Container
} from './button-add-section.styles.jsx';

const MAX_BUTTONS = 4;

const ButtonAddSection = ({ onChange = () => {} }) => {
  const [layout, setLayout] = useState('single');
  const [buttons, setButtons] = useState([
    { text: '', linkType: 'external', link: '' }
  ]);
  const [initialized, setInitialized] = useState(false);

  const generatePayload = () => ({
    content: {
      hasButtons: true
    },
    metadata: { layout, buttons }
  });

  useEffect(() => {
    if (!initialized) {
      onChange(generatePayload());
      setInitialized(true);
    }
  }, [initialized]);

  useEffect(() => {
    if (initialized) {
      onChange(generatePayload());
    }
  }, [layout, buttons]);

  const updateButton = (index, updated) => {
    setButtons((prev) => {
      const newButtons = [...prev];
      newButtons[index] = updated;
      return newButtons;
    });
  };

  const addButton = () => {
    if (buttons.length < MAX_BUTTONS) {
      setButtons([...buttons, { text: '', linkType: 'external', link: '' }]);
    }
  };

  const removeButton = (index) => {
    if (buttons.length === 1) {
      setButtons([{ text: '', linkType: 'external', link: '' }]);
    } else {
      setButtons((prev) => prev.filter((_, i) => i !== index));
    }
  };

  return (
    <Container>
      <Label>Layout</Label>
      <Select value={layout} onChange={(e) => setLayout(e.target.value)}>
        <Option value="single">Single</Option>
        <Option value="block">Block (1-4 full-width buttons)</Option>
      </Select>

      {buttons.map((button, idx) => (
        <ButtonInputRow
          key={idx}
          index={idx}
          data={button}
          update={(updated) => updateButton(idx, updated)}
          remove={() => removeButton(idx)}
          canRemove={buttons.length > 1}
        />
      ))}

      {layout === 'block' && buttons.length < MAX_BUTTONS && (
        <AddButtonRow>
          <AddButton onClick={addButton}>
            <FaPlus /> Add Button
          </AddButton>
        </AddButtonRow>
      )}
    </Container>
  );
};

export default ButtonAddSection;